import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { BsButton, BsCard, BsForm, BsFormControl, BsFormSelect } from '../../collection/bootstrap/BootstrapComponents';
import { useLoad } from '../../collection/Hooks';
import HiddenInput from '../../collection/inputs/HiddenInput';
import { apiGet } from '../../utils/api';

/**
 * Filtro para los días libres.
 * Props:
 * - onFilter(data): Función que se ejecuta cuando se debe actualizar la tabla, la función recibe los datos del formulario de filtro y debe devolver la tabla resultante.
 * - defaultValue: Valores por defecto del filtro.
 * - selectDepartamento, selectTrabajador : Si se incluyen, el filtro incluirá los respectivos campos
 */
export default function DiasLibresFilter(props) {
    const { defaultValue, onFilter, ...otherProps } = props;

    const updateData = () => defaultValue;
    const saveData = async data => {
        if (!data.get("departamentos[]"))
            data.delete("departamentos[]");
        await onFilter(data);
    }

    return <BsForm
        onUpdate={updateData}
        onSave={saveData}>
        <DiasLibresFilterForm selectDepartamento={props.selectDepartamento} selectTrabajador={props.selectTrabajador} />
    </BsForm>;
}

function DiasLibresFilterForm(props) {
    const data = props.data;
    var [userList] = useLoad(props.selectTrabajador ? async () => await apiGet("usuarios/listtrabajadores") : null);
    var [departmentList] = useLoad(props.selectDepartamento ? async () => await apiGet("departamentos/list") : null);

    return <>
        <BsCard header="Filtro" className={props.className}>
            <>
                <Row className="gy-3 mb-3">
                    {/* Fechas */}
                    <Col md="6">
                        <BsFormControl
                            /* Desde */
                            label="Desde" name="desde"
                            value={data.desde}
                            type="date" />
                    </Col>
                    <Col md="6">
                        <BsFormControl
                            /* Hasta */
                            label="Hasta" name="hasta"
                            value={data.hasta}
                            type="date" />
                    </Col>
                </Row>
                <Row className="gy-3">
                    {/* Trabajador */}
                    {props.selectTrabajador ?
                        <Col md="6">
                            <BsFormSelect
                                label="Trabajador" name="trabajador"
                                value={data.trabajador} options={userList} isClearable />
                        </Col> :
                        <HiddenInput name="trabajador" value={data.trabajador} />
                    }
                    {/* Departamentos */}
                    {props.selectDepartamento &&
                        <Col md="6">
                            <BsFormSelect
                                label="Departamentos" name="departamentos[]"
                                value={data.departamentos} options={departmentList}
                                isClearable isMulti />
                        </Col>
                    }
                </Row>
                <div className="d-flex justify-content-center gap-3 mt-3">
                    <BsButton onClick={props.onSubmit}>Mostrar resultados</BsButton>
                </div>
            </>
        </BsCard>
    </>
}
